import { styled } from '@abyss/web/tools/styled';
import { Button } from '@abyss/web/ui/Button';

export const Input = styled('input', {
  dynamic: ({ cssProps: { isGEHAV2 } }) => ({
    color: isGEHAV2 ? '$primary1 !important' : '',
  }),
  border: 'none !important',
  fontSize: 18,
  outlineWidth: '0',
  padding: '0px !important',
  width: '100%',
  '&:focus': {
    boxShadow: 'none',
    textOverflow: 'ellipsis',
  },
  '&.allyFocusWithin:focus': {
    boxShadow: 'none',
  },
  textOverflow: 'ellipsis',
});

export const ButtonContainer = styled(Button, {
  justifyContent: 'center',
  alignItem: 'center',
  '&.abyss-button-root': {
    padding: '4px 16px ',
    height: '32px',
    lineHeight: '20px',
    width: '83px',
    display: 'flex',
    justifyContent: 'center',
    alignItem: 'center',
  },
});

export const CloseButtonContainer = styled(Button, {
  justifyContent: 'center',
  alignItem: 'center',
  '&.abyss-button-root': {
    '&:active, &:focus, &:hover': {
      border: 'none',
      backgroundColor: 'transparent',
      color: '#7D7F81',
    },
    padding: '4px 16px ',
    fontWeight: 400,
    height: '32px',
    lineHeight: '20px',
    width: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItem: 'center',
    backgroundColor: 'transparent',
    color: '#7D7F81',
    border: 'none',
  },
});

export const LayoutGroupStyle = {
  'abyss-layout-group': {
    width: '83px',
    height: '32px',
    marginTop: '4px',
    marginRight: '2px',
  },
};

export const SearchInputCloseButtonStyle = {
  'abyss-layout-group': {
    height: '18px',
    marginTop: '12px',
    marginRight: '2px',
    paddingBottom: '20px',
    paddingRight: '20px',
  },
};

export const LocationInputCloseButtonStyle = {
  'abyss-layout-group': {
    height: '32px',
    marginTop: '12px',
    marginRight: '2px',
  },
};
